
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[id]",
      function () {
        return require("private-next-pages/product/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[id]"])
      });
    }
  